import React, { useState, useEffect, useRef } from "react";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import TemporaryDrawer from "../../main/TemporayDrawer";
import Footer from "../../main/Footer";
import styled from "styled-components";
import { motion } from "framer-motion";
import CurrencyExchangeTwoToneIcon from "@mui/icons-material/CurrencyExchangeTwoTone";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";
import Grid from "@mui/material/Grid";
import { getCodEmpUser } from "../../api/services/AuthService";
import DashboardService from "../../api/services/DashboardService";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link, useNavigate } from "react-router-dom";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
  BarElement,
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  BarController,
  LineController,
} from "chart.js";
import { Pie, Chart, getElementAtEvent } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import PermissionGate from "../../security/PermissionGate";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  Title,
  BarElement,
  LinearScale,
  CategoryScale,
  ChartDataLabels,
  PointElement,
  LineElement,
  BarController,
  LineController,
);

const Header = styled(Box)`
  margin-top: 10px;
`;
const Layout = styled.div`
  background-color: white;
  font-weight: bold;
  width: 95%;
  height: 900px;
  top: 80px;
  margin-top: 20px;
  align-items: stretch;
  justify-content: center;
  margin: 0 auto;
  margin-top: 100px;
`;

const Cards = styled.div`
  display: grid;
  gap: 16px;
  width: 100%;
  align-items: stretch;

  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));

  @media (max-width: 900px) {
    grid-template-columns: 1fr !important;
  }
`;

const Titulo = styled(Typography)`
  color: #4682b4;
  font-weight: bold;
  width: 100%;
  margin-botton: 20px;
`;
const Totalizador = styled(Typography)`
  text-align: center;
  color: #4682b4;
`;

const LinkDash = styled(Link)`
  margin: 0;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 0.00938em;
  display: block;
  color: inherit;
`;

const PieWrapper = styled.div`
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
`;

const BarWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
`;

const DashBoard = () => {
  const [totalSolicitacoes, setTotalSoliciacoes] = useState("");
  const [totalSolicitacoesSolicitadas, setTotalSoliciacoesSolicitadas] =
    useState("");
  const [totalSolicitacoesEnviadasCia, setTotalSoliciacoesEnviadasCia] =
    useState("");
  const [totalSolicitacoesCanceladas, setTotalSoliciacoesCanceladas] =
    useState("");
  const [totalSolicitacoesProcessadas, setTotalSoliciacoesProcessadas] =
    useState("");
  const [totalFaturasAereas, setTotalFaturasAereas] = useState("");
  const [somaValoresAereos, setSomaValoresAereos] = useState("");
  const [periodosAereosLastYear, setPeriodosAereosLastYear] = useState([]);
  const [valoresAereosLastYear, setValoresAereosLastYear] = useState([]);
  const [quantidadeAereosLastYear, setQuantidadeAereosLastYear] = useState([]);

  const [open, setOpen] = useState(false);
  const service = new DashboardService();

  useEffect(() => {
    uploadCounters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const uploadCounters = () => {
    handleToggle();
    let user = getCodEmpUser();
    service
      .getTotalizadores({
        codemp: user,
      })
      .then((response) => {
        setTotalSoliciacoes(response.data.totalReembolsos);
        setTotalSoliciacoesCanceladas(response.data.reembolsosCancelados);
        setTotalSoliciacoesEnviadasCia(response.data.reembolsosEnviadosCias);
        setTotalSoliciacoesProcessadas(response.data.reembolsosProcessados);
        setTotalSoliciacoesSolicitadas(response.data.reembolsosSolicitados);
        setTotalFaturasAereas(response.data.faturasAereas);
        setSomaValoresAereos(
          response.data.sumFaturasAereos != null
            ? response.data.sumFaturasAereos.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })
            : "R$ 0,00",
        );
        setPeriodosAereosLastYear(
          response.data.dataChartFaturaAereos.map(function (periodo) {
            return periodo.mes + "/" + periodo.ano;
          }),
        );
        setValoresAereosLastYear(
          response.data.dataChartFaturaAereos.map(function (periodo) {
            return periodo.somaValores;
          }),
        );
        setQuantidadeAereosLastYear(
          response.data.dataChartFaturaAereos.map(function (periodo) {
            return periodo.quantidade;
          }),
        );
      })
      .catch((erro) => {
        console.log("Error name: ", erro.name);
        console.log("Error message: ", erro.message);
        console.log("Error stack: ", erro.stack);
      })
      .finally(() => {
        handleClose();
        console.log(periodosAereosLastYear);
      });
  };

  const navigate = useNavigate();
  const chartRefPie = useRef();
  const chartRefBar = useRef();

  const onClick = (event) => {
    const selection = getElementAtEvent(chartRefPie.current, event);
    const { index } = selection[0];
    const status = data.labels[index];
    navigate("/reembolso", { replace: true, state: { status: status } });
  };

  const meses = [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novemnro",
    "dezembro",
  ];

  const onClickFaturas = (event) => {
    const selection = getElementAtEvent(chartRefBar.current, event);

    // se o clique não foi em nenhum elemento do gráfico, apenas sai
    if (!selection?.length) return;

    const { index } = selection[0];
    const periodo = periodosAereosLastYear[index];
    const data = periodo.split("/");

    const dataInicio = new Date(data[1], meses.indexOf(data[0]), 1);
    const dataFim = new Date(
      dataInicio.getFullYear(),
      dataInicio.getMonth() + 1,
      0,
    );

    const produto =
      selection[0].datasetIndex === 0 || selection[0].datasetIndex === 2
        ? "AEREO"
        : "TERRESTRE";

    navigate("/fatura", {
      replace: true,
      state: {
        produto,
        invoiceNumber: "",
        disabledAFaturar: true,
        dataInicio,
        dataFim,
      },
    });
  };

  const data = {
    labels: ["Solicitadas", "Enviadas Cia", "Canceladas", "Processadas"],
    datasets: [
      {
        label: "# of Votes",
        data: [
          totalSolicitacoesSolicitadas,
          totalSolicitacoesEnviadasCia,
          totalSolicitacoesCanceladas,
          totalSolicitacoesProcessadas,
        ],
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <TemporaryDrawer />
      <motion.div
        className="reembolso"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Layout className="container">
          <Header>
            <Titulo variant="h5" gutterBottom component="div">
              DASHBOARD
            </Titulo>
          </Header>
          <Cards>
              <PermissionGate roles={["ROLE_REEMBOLSO"]}>
                <Card
                  sx={{
                    width: "100%",
                    height: "100%",
                    minHeight: "24em",
                    border: "1px solid #E0FFFF",
                    backgroundColor: "#F5F5F5",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <LinkDash to="/reembolso">
                    <CardHeader
                      sx={{
                        height: "20px",
                        paddingLeft: 2,
                        paddingTop: 4,
                        paddingBottom: 4,
                      }}
                      titleTypographyProps={{
                        fontSize: "20px",
                        color: "#4682B4",
                      }}
                      title="SOLICITAÇÕES DE REEMBOLSO"
                      avatar={
                        <Avatar
                          variant="square"
                          sx={{
                            backgroundColor: "#4682B4",
                            width: "30px",
                            height: "30px",
                          }}
                          aria-label="recipe"
                        >
                          <CurrencyExchangeTwoToneIcon />
                        </Avatar>
                      }
                    />
                  </LinkDash>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <LinkDash to="/reembolso">
                          <Totalizador
                            variant="h1"
                            gutterBottom
                            component="div"
                          >
                            {totalSolicitacoes}
                          </Totalizador>
                        </LinkDash>
                        <PieWrapper>
                          <Pie
                            data={data}
                            onClick={onClick}
                            ref={chartRefPie}
                            options={{
                              responsive: true,
                              locale: "pt-BR",
                              plugins: {
                                legend: { position: "top" },
                                title: {
                                  display: true,
                                  text: "Status Solicitações",
                                },
                                datalabels: {
                                  color: (ctx) => ctx.dataset.borderColor,
                                  formatter: (value) =>
                                    value === 0 ? null : value,
                                  font: { weight: "bold", size: "18px" },
                                },
                              },
                            }}
                          />
                        </PieWrapper>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </PermissionGate>
              <PermissionGate roles={["ROLE_FATURAS_CONSOLIDADORA"]}>
                <Card
                  sx={{
                    width: "100%",
                    height: "100%",
                    minHeight: "24em",
                    border: "1px solid #E0FFFF",
                    backgroundColor: "#F5F5F5",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <LinkDash to="/fatura">
                    <CardHeader
                      sx={{
                        height: "20px",
                        paddingLeft: 2,
                        paddingTop: 4,
                        paddingBottom: 4,
                      }}
                      titleTypographyProps={{
                        fontSize: "24px",
                        color: "#4682B4",
                      }}
                      title="FATURAS"
                      avatar={
                        <Avatar
                          variant="square"
                          sx={{
                            backgroundColor: "#4682B4",
                            width: "30px",
                            height: "30px",
                          }}
                          aria-label="recipe"
                        >
                          <RequestPageIcon />
                        </Avatar>
                      }
                    />
                  </LinkDash>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <LinkDash
                      to="/fatura"
                      state={{
                        produto: "AEREO",
                        invoiceNumber: "",
                        disabledAFaturar: true,
                      }}
                    >
                      <Totalizador variant="h5" gutterBottom component="div">
                        TOTAL: {totalFaturasAereas} / {somaValoresAereos}
                      </Totalizador>
                    </LinkDash>
                    <BarWrapper>
                      <Chart
                        type="bar"
                        onClick={onClickFaturas}
                        ref={chartRefBar}
                        options={{
                          responsive: true,
                          locale: "pt-BR",
                          scales: {
                            y: {
                              ticks: {
                                callback: (value) =>
                                  new Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                    maximumFractionDigits: 2,
                                  }).format(value),
                              },
                              position: "left",
                            },
                            y1: {
                              position: "right",
                              grid: { drawOnChartArea: false },
                            },
                          },
                          plugins: {
                            legend: { position: "top" },
                            title: {
                              display: true,
                              text: "Resultado Mensal Último Ano",
                            },
                            datalabels: { labels: { title: null } },
                            tooltip: {
                              callbacks: {
                                label: (context) => {
                                  if (context.dataset.yAxisID === "y") {
                                    return (
                                      "Faturamento: " +
                                      new Intl.NumberFormat("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                        maximumFractionDigits: 2,
                                      }).format(context.parsed.y)
                                    );
                                  }
                                  return context.parsed.y + " Faturas";
                                },
                              },
                            },
                          },
                        }}
                        data={{
                          labels: periodosAereosLastYear,
                          datasets: [
                            {
                              label: "Faturamento Total",
                              data: valoresAereosLastYear,
                              backgroundColor: "rgba(255, 99, 132, 0.5)",
                              type: "bar",
                              yAxisID: "y",
                            },
                            {
                              type: "line",
                              label: "Qtd. Faturas",
                              borderColor: "rgb(53, 162, 235)",
                              backgroundColor: "rgba(53, 162, 235, 0.5)",
                              borderWidth: 2,
                              data: quantidadeAereosLastYear,
                              yAxisID: "y1",
                            },
                          ],
                        }}
                      />
                    </BarWrapper>
                  </CardContent>
                </Card>
              </PermissionGate>
          </Cards>
        </Layout>
      </motion.div>
      <Footer />
    </>
  );
};

export default DashBoard;
